<template>
  <transition name="fade">
    <base-modal v-if="show" class="modal-action-confirmation" required>
      <template v-slot:content>
        <base-icon
          :style="`color: ${colorIcon}`"
          width="88px"
          height="88px"
          :name="icon"
        />
        <div class="title-modal" v-if="title">{{ title }}</div>
        <p>{{ message }}</p>
        <div class="actions-wrapper">
          <button @click="cancel" class="button is-gray" type="button">
            {{ btnCancelText }}
          </button>
          <button @click="confirm" class="button is-primary" type="button">
            {{ btnConfirmText }}
          </button>
        </div>
      </template>
    </base-modal>
  </transition>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'

export default {
  props: {
    icon: {
      type: String,
      default: 'painel/info-modern-icon',
    },
    colorIcon: {
      type: String,
      default: '#F65C6A',
    },
    title: {
      type: String,
      default: '  ',
    },
    message: {
      type: String,
      default: 'Tem certeza que deseja excluir?',
    },
    btnConfirmText: {
      type: String,
      default: 'Sim, excluir',
    },
    btnCancelText: {
      type: String,
      default: 'Não',
    },
  },

  components: {
    BaseModal,
  },

  data() {
    return {
      show: false,
      data: undefined,
    }
  },

  methods: {
    open(data) {
      this.show = true
      this.data = data
    },

    close() {
      this.show = false
    },

    confirm() {
      this.$emit('confirmed', this.data)
      this.close()
    },

    cancel() {
      this.$emit('cancelled', this.data)
      this.close()
    },
  },
}
</script>

<style lang="scss">
.modal-action-confirmation {
  .c-base-modal__wrapper {
    padding: 40px;
    border-radius: 16px;
    max-width: calc(100% - 32px);
    @media screen and (min-width: 480px) {
      max-width: 460px;
    }
  }

  .actions-wrapper {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: 480px) {
      flex-direction: row;
    }
  }

  p {
    margin: 24px auto;
    color: $neutral;
    font-size: 16px;
  }

  button {
    font-size: 16px;
  }
  .title-modal {
    color: $gray-7;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }
}
</style>
